<ng-container>
  <div>
    <ul class="space-y-3" style="flex-grow: 1; list-style: none; padding: 0; margin: 0;">
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Edit flow's JSON definition directly
      </li>
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Easily Migrate sets of flows
      </li>
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Restore Flow to previous snapshot
      </li>
    </ul>

    @if (showTiles) {
      <div class="grid grid-cols-3 gap-2 mt-4">
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="edit" class="text-sm mb-1"></fa-icon>
          Edit JSON
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="file-import" class="text-sm mb-1"></fa-icon>
          Migrate
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="history" class="text-sm mb-1"></fa-icon>
          <span title="Restore Flow to previous snapshot">Restore Flow</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="search" class="text-sm mb-1"></fa-icon>
          Full Text Search
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="user-cog" class="text-sm mb-1"></fa-icon>
          <span title="View as Admin">View as Admin</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="project-diagram" class="text-sm mb-1"></fa-icon>
          Flow Diagram
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="file-download" class="text-sm mb-1"></fa-icon>
          <span title="Export to Excel">Export to Excel</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="stream" class="text-sm mb-1"></fa-icon>
          Runs Filtering
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="stopwatch" class="text-sm mb-1"></fa-icon>
          Runs Timing
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="filter" class="text-sm mb-1"></fa-icon>
          Filter by Action
        </div>
      </div>
    }
  </div>
</ng-container>
